<script setup lang="ts">
const { locale, locales, setLocale } = useI18n()

const currentLocale = computed({
  get: () => locale.value,
  set: val => { locale.value = val }
})

const availableLocales = computed(() => {
  return locales.value.map((locale) => ({
    label: locale.name,
    value: locale.code,
  }))
})

watch(currentLocale, () => {
  setLocale(currentLocale.value)
})
</script>

<template>
  <div class="ui-group-select">
    <USelect v-model="currentLocale" class="cursor-pointer" :items="availableLocales" value-key="value" variant="ghost" color="primary" />
  </div>
</template>
